import React from 'react';

import LinearProgress from '@mui/material/LinearProgress';
import { Box, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EmptyState from 'common/components/EmptyState';

import EmptyContacts from 'resources/EmptyContacts.svg?react';

import { getFormattedContacts } from '../helpers';

import ListItems from './ListItems';

const EmptyStateAndList = ({
    contacts,
    filterData,
    handleClickBulkItems,
    handleClickCreate,
    handleSaveRow,
    isFetching,
    paginationData,
    rowCount,
    selectionModel,
    setFilterData,
    setSelectionModel,
    showEmptyState,
    tableSettings,
}) => {
    const { t } = useTranslation();

    if (isFetching)
        return (
            <Box height={460}>
                <LinearProgress />
            </Box>
        );

    if (!isFetching && showEmptyState.show)
        return (
            <Grid container justifyContent="center">
                <Grid size={{ lg: 6, md: 10, xs: 'grow' }}>
                    {showEmptyState?.status === 'active' ? (
                        <EmptyState
                            caption={t(
                                'Add your customers with their contact information. You will see a complete list here where you will be able to access them',
                            )}
                            onClick={() => handleClickCreate()}
                            srcSvg={<EmptyContacts />}
                            sxCard={{
                                border: 0,
                                boxShadow: 'none !important',
                            }}
                            textButton={t('Add')}
                            title={t('No active contacts')}
                        />
                    ) : (
                        <EmptyState
                            srcSvg={<EmptyContacts />}
                            sxCard={{ border: 0, boxShadow: 'none' }}
                            title={t('No archived contacts')}
                        />
                    )}
                </Grid>
            </Grid>
        );

    return (
        <ListItems
            filterData={filterData}
            handleClickBulkItems={handleClickBulkItems}
            handleSaveRow={handleSaveRow}
            isFetching={isFetching}
            items={getFormattedContacts(contacts)}
            paginationData={paginationData}
            rowCount={rowCount}
            selectionModel={selectionModel}
            setFilterData={setFilterData}
            setSelectionModel={setSelectionModel}
            tableSettings={tableSettings}
        />
    );
};

EmptyStateAndList.propTypes = {
    contacts: PropTypes.array,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickCreate: PropTypes.func,
    handleSaveRow: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    rowCount: PropTypes.number,
    selectionModel: PropTypes.array,
    setFilterData: PropTypes.func,
    setSelectionModel: PropTypes.func,
    showEmptyState: PropTypes.object,
    tableSettings: PropTypes.array,
};

export default EmptyStateAndList;
